import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { SortimentDTO } from "~app/common/models/common/SortimentDTO";
import { SortimentRedigeraDialogComponent } from "../sortiment-redigera-dialog/sortiment-redigera-dialog.component";

@Component({
    selector: "rask-sortiment-list",
    templateUrl: "./sortiment-list.component.html",
    styleUrls: ["./sortiment-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        TranslatePipe
    ]
})
export class SortimentListComponent {
    @Input() sortiment: SortimentDTO[];

    private readonly modalService = inject(NgbModal);

    update(sortiment: SortimentDTO) {
        const found = this.sortiment.filter(s => s.id === sortiment.id);
        if (found && found.length > 0) {
            const current = found[0];
            current.id = sortiment.id;
            current.kod = sortiment.kod;
            current.namn = sortiment.namn;
            current.aktiv = sortiment.aktiv;
            current.produktgruppId = sortiment.produktgruppId;
            current.produktgruppNamn = sortiment.produktgruppNamn;
        }
    }

    open = (event: Event, sortiment = null) => {
        event.preventDefault();
        if (!this.modalService.hasOpenModals()) {
            const modalRef = this.modalService.open(SortimentRedigeraDialogComponent, {
                keyboard: false,
                backdrop: "static",
                size: "lg"
            });
            modalRef.componentInstance.sortimentId = sortiment && sortiment.id ? sortiment.id : null;
            modalRef.result.then((result) => {
                this.update(result);
            }, (reason) => {
                // Fånga error
            });
        }
    };
}
